import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import './styles.scss'
import Discount from './discount'

import moreInfo from './assets/more_info.svg'

const modalRoot = document.getElementById('discount') as HTMLElement;


class DiscountMain extends Component<any, any> {


    public render() {
        return (
            ReactDOM.createPortal(
                <Discount/>,
                modalRoot
            )
        )

    }
}



export default DiscountMain